/* eslint-disable no-console */
import { appStore } from "@app/store/store"
import { IframeMessages, ORDER_LINE_TYPES, TICKET_TYPES } from "./constants"

const tracking = {}

tracking.addTradeDeskPixel = (order = {}) => {
	let ticketInfo = {
		orderNumber: order.orderCode,
		revenue: 0.0,
		ids: [],
		exists: false,
	}
	let voucherInfo = {
		orderNumber: order.orderCode,
		revenue: 0.0,
		ids: [],
		exists: false,
	}
	let articleInfo = {
		orderNumber: order.orderCode,
		revenue: 0.0,
		ids: [],
		exists: false,
	}
	order.orderLines = order.orderLines ?? []
	order.orderLines.forEach(line => {
		line.details.forEach(detail => {
			if (detail.typeId === ORDER_LINE_TYPES.Article && !detail.feeId && detail.articleGroup == "BLUPHORIA") {
				articleInfo.exists = true
				let amount = detail.amounts.reduce((value, current) => {
					return value + current.grossAmount
				}, 0)
				articleInfo.ids.push(detail.articleId)
				articleInfo.revenue += amount
			} else if (detail.typeId === ORDER_LINE_TYPES.Voucher) {
				voucherInfo.exists = true
				let amount = detail.amounts.reduce((value, current) => {
					return value + current.grossAmount
				}, 0)
				voucherInfo.ids.push(detail.voucherId)
				voucherInfo.revenue += amount
			} else if (detail.typeId === ORDER_LINE_TYPES.Ticket) {
				ticketInfo.exists = true
				let amount = detail.amounts.reduce((value, current) => {
					return value + current.grossAmount
				}, 0)
				ticketInfo.ids.push(detail.ticketId)
				ticketInfo.revenue += amount
			}
		})
	})

	let urls = []
	if (ticketInfo.exists) {
		let url = appStore.get("settings.tradeDeskTicketPixel")
		let ids = ticketInfo.ids.reduce((o, n) => {
			return o + (o.length > 0 ? ";" : "") + n
		}, "")
		url = url.replace("{orderid}", ticketInfo.orderNumber)
		url = url.replace("{revenue}", ticketInfo.revenue)
		url = url.replace("{td1}", ids)
		urls.push(url)

		if (process.env.NODE_ENV == "development") {
			console.log("Tradedesk pixel ticket: ")
			console.log(url)
		}
	}
	if (voucherInfo.exists) {
		let url = appStore.get("settings.tradeDeskVoucherPixel")
		let ids = voucherInfo.ids.reduce((o, n) => {
			return o + (o.length > 0 ? ";" : "") + n
		}, "")
		url = url.replace("{orderid}", voucherInfo.orderNumber)
		url = url.replace("{revenue}", voucherInfo.revenue)
		url = url.replace("{td1}", ids)
		urls.push(url)

		if (process.env.NODE_ENV == "development") {
			console.log("Tradedesk pixel voucher: ")
			console.log(url)
		}
	}
	if (articleInfo.exists) {
		let url = appStore.get("settings.tradeDeskBluphoriaPixel")
		let ids = articleInfo.ids.reduce((o, n) => {
			return o + (o.length > 0 ? ";" : "") + n
		}, "")
		url = url.replace("{orderid}", articleInfo.orderNumber)
		url = url.replace("{revenue}", articleInfo.revenue)
		url = url.replace("{td1}", ids)
		urls.push(url)

		if (process.env.NODE_ENV == "development") {
			console.log("Tradedesk pixel articles: ")
			console.log(url)
		}
	}

	for (let url of urls) {
		window.parent.postMessage(IframeMessages.tackTradeDesk + ";" + url, "*")
	}
}

tracking.pageView = pageName => {
	sendGoogleEvent({
		event: "pageView",
		page: pageName,
	})
}

tracking.signUpStart = () => {
	sendGoogleEvent({
		event: "sign_up_start",
	})
}
tracking.signUpComplete = () => {
	sendGoogleEvent({
		event: "sign_up",
	})
}
/**
 *
 * @param {"Gast" | "Kunde"} loginType
 */
tracking.login = loginType => {
	sendGoogleEvent({ event: "login", login: loginType })
}
tracking.forgotPassword = () => {
	sendGoogleEvent({ event: "forgot_password" })
}
tracking.deleteAccount = () => {
	sendGoogleEvent({ event: "delete_account" })
}

tracking.personTypes = () => {
	let visitors = appStore.get("order.visitorKinds")

	let personTypes = Object.keys(visitors).map(key => {
		let kind = visitors[key]
		return {
			quantity: kind.cnt,
			personType: kind.visitor.visitorKind,
		}
	})
	sendGoogleEvent({
		event: "persons",
		personTypes,
	})
}

tracking.date = () => {
	const date = appStore.get("order.selectedDay").date
	const tb = appStore.get("order.selectedTb")
	const ts = appStore.get("order.selectedTs")

	const isDay = tb.timeBlockTypeId === TICKET_TYPES.WholeDay
	const time = isDay ? null : `${ts.timeFrom.substring(0, ts.timeFrom.length - 3)} - ${ts.timeTo.substring(0, ts.timeTo.length - 3)}`

	sendGoogleEvent({
		event: "date",
		date,
		day: isDay,
		hour: time,
	})
}

tracking.beds = automatically => {
	const bedTypes = (appStore.get("order.loungers") || []).map(e => e.objectGroup)
	sendGoogleEvent({
		event: "beds",
		chosen: bedTypes && bedTypes.length > 0 ? true : false,
		types: bedTypes,
		automatically: automatically,
	})
}

tracking.beginCheckout = order => {
	let data = getGoogleCartData(order)
	sendGoogleEvent({
		event: "begin_checkout",
		...data,
	})
	sendGoogleEvent({
		event: "checkout",
	})
}

tracking.bluphoriaConfirm = cnt => {
	sendGoogleEvent({
		event: "bluephoriaStep",
		itemCnt: cnt,
	})
}

tracking.addToCart = (item, isOrderLine = false) => {
	const { articleId, price, title } = item

	let data
	if (!isOrderLine) {
		data = {
			event: "add_to_cart",
			currency: "EUR",
			value: price,
			items: [
				{
					item_id: getDetailId({ typeId: item.typeId || ORDER_LINE_TYPES.Article, articleId }), //if we have a real product it's always an article
					item_name: title,
					index: 0,
					price: price,
					quantity: 1,
				},
			],
		}
	} else {
		data = {
			event: "add_to_cart",
			currency: "EUR",
			value: item.details[0].unitPrice,
			items: [
				{
					item_id: getDetailId(item.details[0]),
					item_name: item.description || item.details[0].description,
					index: 0,
					price: item.details[0].unitPrice,
					quantity: 1,
				},
			],
		}
	}
	sendGoogleEvent(data)
}

tracking.addPromotionCode = promoCode => {
	sendGoogleEvent({
		event: "add_promotioncode",
		code: promoCode,
	})
}

tracking.addShippingInfo = order => {
	sendGoogleEvent({
		event: "add_shipping_info",
		...getGoogleCartData(order),
	})
}

tracking.addPaymentInfo = (order, paymentType) => {
	let data = getGoogleCartData(order)
	sendGoogleEvent({
		event: "add_payment_info",
		payment_type: paymentType,
		...data,
	})
}

tracking.addParkingTicket = parkingTicket => {
	tracking.addToCart({ price: parkingTicket.price, title: parkingTicket.name, articleId: parkingTicket.ticketId, typeId: ORDER_LINE_TYPES.Ticket })
}
tracking.removeParkingTicket = parkingTicket => {
	tracking.removeFromCart({ price: parkingTicket.price, title: parkingTicket.name, articleId: parkingTicket.ticketId, typeId: ORDER_LINE_TYPES.Ticket })
}

tracking.addLounger = lounger => {
	tracking.addToCart({ price: lounger.price, title: lounger.objectGroup, articleId: lounger.objectGroupId, typeId: ORDER_LINE_TYPES.ObjectGroup })
}
tracking.removeLounger = lounger => {
	tracking.removeFromCart({ price: lounger.price, title: lounger.objectGroup, articleId: lounger.objectGroupId, typeId: ORDER_LINE_TYPES.ObjectGroup })
}

tracking.addMassage = massage => {
	tracking.addToCart({ price: massage.grossAmount, title: massage.massage, articleId: massage.activityId, typeId: ORDER_LINE_TYPES.Activity })
}
tracking.removeMassage = massage => {
	massage = massage.details ? massage.details[0] : massage
	const amount = massage.grossAmount
	tracking.removeFromCart({ price: amount, title: massage.massage, articleId: massage.activityId, typeId: ORDER_LINE_TYPES.Activity })
}
tracking.addThermencardRefill = thermencardRefill => {
	thermencardRefill = thermencardRefill.details ? thermencardRefill.details[0] : thermencardRefill

	const amount = thermencardRefill.amount || thermencardRefill.unitPrice
	tracking.addToCart({
		price: amount,
		title: thermencardRefill.accountTemplate || thermencardRefill.description,
		articleId: thermencardRefill.accountTemplateI,
		typeId: ORDER_LINE_TYPES.Account,
	})
}
tracking.removeThermencardRefill = thermencardRefill => {
	thermencardRefill = thermencardRefill.details ? thermencardRefill.details[0] : thermencardRefill
	const amount = thermencardRefill.amount || thermencardRefill.unitPrice
	tracking.removeFromCart({
		price: amount,
		title: thermencardRefill.accountTemplate || thermencardRefill.description,
		articleId: thermencardRefill.accountTemplateI,
		typeId: ORDER_LINE_TYPES.Account,
	})
}

//Send the current selected visitorkinds and tickets as an add_to_cart event to google
tracking.addTickets = () => {
	let visitors = appStore.get(state => state.order.visitorKinds)
	let sTb = appStore.get(state => state.order.selectedTbKind)
	let tb = appStore.get(state => state.order.selectedTb)

	if (visitors && sTb && tb) {
		let items = []
		const { items: timeBlockItems, price: fullPrice } = tb
		const { event: title } = sTb
		const typeId = ORDER_LINE_TYPES.Ticket
		Object.keys(visitors).forEach(key => {
			const entry = visitors[key]
			const {
				cnt: quantity,
				visitor: { visitorKindId },
			} = entry
			const { ticketId, price } = timeBlockItems.find(e => e.visitorKindId === visitorKindId)

			items.push({
				item_id: getDetailId({ typeId, articleId: ticketId }),
				item_name: title,
				index: items.length,
				price: price,
				quantity: quantity,
			})
		})
		sendGoogleEvent({
			event: "add_to_cart",
			currency: "EUR",
			value: fullPrice,
			items,
		})
	}
}

//Send the current selected visitorkinds and tickets as an add_to_cart event to google
tracking.removeTickets = () => {
	let visitors = appStore.get(state => state.order.visitorKinds)
	let sTb = appStore.get(state => state.order.selectedTbKind)
	let tb = appStore.get(state => state.order.selectedTb)

	if (visitors && sTb && tb) {
		let items = []
		const { items: timeBlockItems, price: fullPrice } = tb
		const { event: title } = sTb
		const typeId = ORDER_LINE_TYPES.Ticket
		Object.keys(visitors).forEach(key => {
			const entry = visitors[key]
			const {
				cnt: quantity,
				visitor: { visitorKindId },
			} = entry
			const { ticketId, price } = timeBlockItems.find(e => e.visitorKindId === visitorKindId)

			items.push({
				item_id: getDetailId({ typeId, articleId: ticketId }),
				item_name: title,
				index: items.length,
				price: price * quantity,
				quantity: quantity,
			})
		})
		sendGoogleEvent({
			event: "remove_from_cart",
			currency: "EUR",
			value: fullPrice,
			items,
		})
	}
}

tracking.removeFromCart = (item, isOrderLine = false) => {
	const { articleId, price, title } = item
	let data
	if (!isOrderLine) {
		data = {
			event: "remove_from_cart",
			currency: "EUR",
			value: price,
			items: [
				{
					item_id: getDetailId({ typeId: item.typeId || ORDER_LINE_TYPES.Article, articleId }), //if we have a real product it's always an article
					item_name: title,
					index: 0,
					price: price,
					quantity: 1,
				},
			],
		}
	} else {
		data = {
			event: "remove_from_cart",
			currency: "EUR",
			value: item.details[0].unitPrice * (item.quantity || 1),
			items: [
				{
					item_id: getDetailId(item.details[0]),
					item_name: item.description || item.details[0].description,
					index: 0,
					price: item.details[0].unitPrice,
					quantity: item.quantity || 1,
				},
			],
		}
	}
	sendGoogleEvent(data)
}

tracking.startPurchase = order => {
	sendGoogleEvent({
		event: "purchase_start",
		shipping: order.transporterAmount,
		tax: order.totalTaxAmount,
		...getGoogleCartData(order),
	})
}
tracking.purchase = order => {
	sendGoogleEvent({
		event: "purchase",
		transaction_id: order.webToken,
		shipping: order.transporterAmount,
		tax: order.totalTaxAmount,
		...getGoogleCartData(order),
	})
}

function sendGoogleEvent(data) {
	if (appStore.get("core.kioskMode")) {
		return
	}
	if (data && appStore.get("core.htgGuestData")) {
		data.isHTG = true
	}
	window.parent.postMessage(IframeMessages.googleEvent + ";" + JSON.stringify(data), "*")
	if (process.env.NODE_ENV == "development") {
		console.log(data)
	}
	// window.parent.postMessage(data, '*');
}

function getGoogleCartData(order) {
	let { priceActionCodes, payAmount, orderLines } = order
	if (!priceActionCodes) {
		//its not a formattedOrder it is a saved order. The structure is not the same

		;((priceActionCodes = []),
			order.orderLines.forEach(line => {
				line.details.forEach(detail => {
					detail.amounts.forEach(amount => {
						let code = amount.priceActionCode
						if (code && priceActionCodes.indexOf(code) == -1) {
							priceActionCodes.push(code)
						}
					})
				})
			}))
	}
	let data = {
		currency: "EUR",
		value: payAmount,
		coupon: priceActionCodes.join(","),
		items: [],
	}

	for (let line of orderLines) {
		for (let detail of line.details) {
			if (
				detail.typeId === ORDER_LINE_TYPES.Article ||
				detail.typeId === ORDER_LINE_TYPES.Object ||
				detail.typeId === ORDER_LINE_TYPES.ObjectGroup ||
				detail.typeId === ORDER_LINE_TYPES.Ticket ||
				detail.typeId === ORDER_LINE_TYPES.Voucher
			) {
				let typeId = detail.typeId === ORDER_LINE_TYPES.Object ? ORDER_LINE_TYPES.ObjectGroup : detail.typeId

				data.items.push({
					item_id: getDetailId({ ...detail, typeId }),
					item_name: line.description || detail.description,
					discount: detail.amounts.filter((__, i) => i !== 0).reduce((v, n) => v + n.grossAmount, 0) * -1,
					index: line.details.indexOf(detail),
					price: detail.unitPrice,
					quantity: detail.quantity || line.quantity,
				})
			}
		}
	}

	return data
}

function getDetailId(detail) {
	return (
		detail.typeId + ";" + (detail.objectGroupId || detail.ticketId || detail.voucherId || detail.articleId || detail.accountTemplateId || detail.collectionId)
	)
}

export default tracking
